import { FeedbackArea } from '../config/schema/FeedbackAreas';
import { store } from '../store/store';
import { getFeedBackArea } from '../config/FeedbackConfig';

export function getFeedbackAreasForSelection(): FeedbackArea[] {
    return getFeedBackArea(store.selectedFeedbackArea);
}
